import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
	html, body, #root {
		height: 100%;
	}
    *{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		outline: 0;
	}
	body {
		background: ${props => props.theme?.mode === 'dark' ? props.theme.colors.background : '#FFFFFF'};
		color: ${props => props.theme?.colors?.text || '#212529'};
		-webkit-font-smoothing: antialiased;

		.MuiRadio-colorSecondary.Mui-checked{
			color: #DD6435;
		}

		.MuiCheckbox-colorSecondary.Mui-checked{
			color: #DD6435;
		}

		.PrivateSwitchBase-root-1{
			padding: 0;
		}

		.modalDeactivateProperty{
			padding: 0 0 24px 0;
		}

		.modalConsult{
			padding: 0 !important;
			margin: 0 !important;
			border-radius: 12px;
			max-height: min(90dvh, 90vh, 900px) !important;
			overflow: hidden !important;

			.react-responsive-modal-closeButton{
				top: 14px;
				right: 14px;
			}
		}

		.modalClients{
			padding: 0;
			padding-bottom: 12px;

			margin: 0;

			border-radius: 4px;

			top: 50px;

			.react-responsive-modal-closeButton{
				top: 26px;
			}
		}

		.modalSchedule{
			padding: 0;
			padding-bottom: 12px;

			margin: 0;

			border-radius: 4px;

			top: 25px;

			.react-responsive-modal-closeButton{
				top: 26px;
			}
		}

		.modalPropertiesPerConsultant{
			.react-responsive-modal-closeButton{
				top: 22px;
			}
		}

		.menu{
			top: 0;
			left: 0;

			padding: 0;
			margin: 0;

			max-width: 100%;
			width: 100%;
		}

		.remove-photo-modal{
			margin: 15% auto;
		}

		.schedule-lock-note-modal{
			margin: 6% auto;
			padding: 1.25rem 1.5rem;
			border: 1px solid #e2e8f0;
			border-radius: 0.75rem;
			overflow: hidden;
			max-width: 28rem;
			width: calc(100% - 2rem);
		}

		.photo-ai-prompt-modal{
			margin: 6% auto;
			padding: 1.25rem 1.5rem;
			border: 1px solid #e2e8f0;
			border-radius: 0.75rem;
			overflow: hidden;
			max-width: 42rem;
			width: calc(100% - 2rem);
		}

		.create-card-from-schedule-modal{
			margin: 4% auto;
			padding: 1.25rem 1.5rem;
			border: 1px solid #e2e8f0;
			border-radius: 0.75rem;
			overflow: visible;
			max-width: 40rem;
			width: calc(100% - 2rem);
		}

		.change-user-role-modal{
			margin: 6% auto;
			padding: 1.25rem 1.5rem;
			border: 1px solid #e2e8f0;
			border-radius: 0.75rem;
			overflow: hidden;
			max-width: 28rem;
			width: calc(100% - 2rem);
		}

		@media(max-width: 767px){
			.modalConsult{
				max-width: none !important;
				width: calc(100vw - 1rem) !important;
				max-height: min(92dvh, 92vh) !important;
				margin: 0 !important;
				overflow: hidden !important;
			}

			.modalVisitsPerConsultant{
				max-width: 330px;

				display: flex;

				top: 50px;
				margin: 0 auto;
			}

			.modalClients{
				max-width: 330px;

				display: flex;

				top: 50px;

				margin: 0 auto;
			}

			.modalSchedule{
				max-width: 330px;

				display: flex;

				top: 50px;
				margin: 0 auto;
			}

			.modalPropertiesPerConsultant{
				top: 50px;
				margin: 0 auto;
			}

			.remove-photo-modal{
				width: 90%;

				margin: 50% auto;
			}

			.schedule-lock-note-modal{
				margin: 25% auto;
				padding: 1rem 1.25rem;
			}

			.photo-ai-prompt-modal{
				margin: 25% auto;
				padding: 1rem 1.25rem;
			}

			.create-card-from-schedule-modal{
				margin: 8% auto;
				padding: 1rem 1.25rem;
				max-width: calc(100vw - 1rem);
			}

			.change-user-role-modal{
				margin: 25% auto;
				padding: 1rem 1.25rem;
			}

			.modalDeactivateProperty{
				margin: 25% auto;
			}

		}
		#modal{
			display: flex;
		}

	}

	a{
		text-decoration: none;
		color: #FFFFFF;
	}

	body, input, button, textarea {
		font-size: 16px;
		font-family: 'Montserrat', sans-serif;
	}
	h1, h2, h3, h4, h5, h6, strong{
		font-weight: 400;
	}
	button{
		cursor: pointer;
		background: transparent;
		border: 0;
	}
`;
